import type { FC } from 'react';
import { useTheme } from 'styled-components';
import type { IIconsProps } from './types';
import { IconScale } from './types';

const ArrowsDown: FC<IIconsProps> = ({
  color,
  size = IconScale.M,
  width = 0,
  height = 0,
}: IIconsProps) => {
  const theme = useTheme();
  if (!color) {
    color = theme.palette.primary.main;
  }
  return (
    <svg
      width={width || size}
      height={height || size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.99856 10.9992L7.99933 11L12.6678 6.33148L11.3364 5L7.99861 8.33774L4.664 5.00313L3.33252 6.33462L7.99785 10.9999L7.99856 10.9992Z"
        fill={color}
      />
    </svg>
  );
};

export default ArrowsDown;
